<nz-cascader *ngIf="editable" [nzShowSearch]="true" [nzOptions]="locationOptions" [(ngModel)]="locationIds"
	(ngModelChange)="onLocationChange($event)" (focus)="onFocus()" [nzDisabled]="disabled">
</nz-cascader>

<format-data *ngIf="!editable" [contentStr]="location" [patternStr]="patternStr">
</format-data>